module.exports = __webpack_public_path__ + "static/ceremony-3f71f639ad3aa8fb6f92f5747881fa46.png";